import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AppConstants } from 'src/app/constants/app-constants';
import { SignupEntry } from 'src/app/model/SignupEntry';
import { SignupRecord } from 'src/app/model/SignupRecord';
import { environment } from 'src/environments/environment';
import { SIGNUP_BY_GUID_ENDPOINT, SIGNUP_ENDPOINT } from 'src/app/constants/api-routes';

/**
 * Signup Service provides the functionality to sign up for an account
 */
@Injectable({
  providedIn: 'root'
})
export class SignupService {
  /** Default constructor to initialize services */
  constructor(
    private _http: HttpClient,
  ) { }

  /**
   * Get the signup record associated with a provided GUID
   * 
   * @param guid The GUID to search for
   * @return The signup record associated with the GUID, null if none
   */
  public getSignupRecord(guid: string): Observable<SignupRecord | null> {
    return this._http.get<SignupRecord | null>(SIGNUP_BY_GUID_ENDPOINT(guid));
  }

  /**
   * Create a new user with provided user credentials
   * 
   * @param user New user to sign up
   */
  public signup(user: SignupEntry): Observable<any> {
    return this._http.post<any>(SIGNUP_ENDPOINT, user);
  }

}
